export const DEFAULT_FILTER_OFFSET = 0;
export const DEFAULT_FILTER_LIMIT = 75;

// Primary debounce constant for search/filter inputs
export const DEBOUNCE_DURATION_MS = 500;
